import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { KcIconButtonComponent } from '@kaspacom/ui-kit';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [KcIconButtonComponent],
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeToggleComponent {
  readonly themeService = inject(ThemeService);

  readonly icon = () =>
    this.themeService.theme() === 'dark' ? 'theme' : 'theme';
  readonly label = () =>
    this.themeService.theme() === 'dark'
      ? 'Switch to light mode'
      : 'Switch to dark mode';
}
